import { render, staticRenderFns } from "./ModuleSelector.vue?vue&type=template&id=40e7a382&"
import script from "./ModuleSelector.vue?vue&type=script&lang=js&"
export * from "./ModuleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports